import axios from 'axios';

const http = axios.create({
	baseURL: app.api_url,
});

export default http;